import React, { useState } from 'react';

const HierarchyInnerItem = (props) => {
  const { activated, docType, guid, humanId, itemsCount, children } = props.props;

  return (
    <div className="item-contents">
      <div className="item-header">
        <span className="document-title">
          {docType} {humanId} Строк: [{itemsCount}]
          {activated ? (
            <i className="fe-thumbs-up active" />
          ) : (
            <i className="fe-thumbs-down not-active" />
          )}
        </span>
      </div>
    </div>
  );
};

export default HierarchyInnerItem;
